var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExtracBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 30,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69238 18.3077V1L10.6155 1.96154L12.5385 1L14.458 1.96154L16.4033 1L18.3078 1.96154L20.2182 1L22.1371 1.96154L24.077 1L26.0007 1.96154L27.9232 1V14.4615",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9231 14.4614V21.1922C27.9231 22.4673 27.4166 23.6901 26.515 24.5917C25.6134 25.4934 24.3905 25.9999 23.1154 25.9999M23.1154 25.9999C21.8403 25.9999 20.6175 25.4934 19.7159 24.5917C18.8143 23.6901 18.3077 22.4673 18.3077 21.1922V18.3076H1.96158C1.83499 18.3065 1.70945 18.3306 1.59229 18.3785C1.47512 18.4264 1.36868 18.4972 1.27916 18.5867C1.18965 18.6762 1.11887 18.7827 1.07094 18.8998C1.02302 19.017 0.998915 19.1425 1.00004 19.2691C1.00004 23.1153 1.40509 25.9999 5.80773 25.9999H23.1154Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5386 6.76904H24.077",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3848 11.5771H24.0771",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtracBlackIcon);
export default __webpack_public_path__ + "static/media/extracBlackIcon.d9113213e33a5a11321b52f5f5088dd1.svg";
export { ForwardRef as ReactComponent };